import React from 'react';

import LatestStatus from '../latestStatus.jsx';
import viewStatuses from '../viewStatus';

export const viewStatusToUrl = {
    [viewStatuses.AGREEMENT_SENT]: '/behandle-avtaleforslag',
    [viewStatuses.AGREEMENT_ACCEPTED]: '/avtale-godkjent',
    [viewStatuses.PAID]: '/send-varen',
    [viewStatuses.PAYMENT_DELAYED]: '/utsatt-betaling',
    [viewStatuses.PAYMENT_REVERTED]: '/handel-kansellert',
    [viewStatuses.PAYMENT_EXPIRED]: '/betalingsfrist-har-gatt-ut',
    [viewStatuses.ITEM_APPROVED]: '/varen-er-godkjent',
    [viewStatuses.DISCOUNT_SUGGESTED]: '/losning/avslag-foreslatt',
    [viewStatuses.DISCOUNT_APPROVED]: '/losning/enighet-om-avslag',
};

export default () => <LatestStatus viewStatusToUrl={viewStatusToUrl} />;



// WEBPACK FOOTER //
// ./safeTrade/seller/safeTradeSellerStatus.jsx